import tw, { styled } from "twin.macro"

export const HamburgerButton = styled.button`
    ${tw`cursor-pointer lg:hidden border-0 outline-none bg-transparent`}
`;
